import * as actionTypes from "Redux/Actions/actionTypes";

const initialState = {
  success: "",
  error: "",
};

const UpdateApplicantReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_APPLICANT_RESPONSE:
      return {
        ...state,
        success: action.success,
      };

    case actionTypes.UPDATE_APPLICANT_ERROR:
      return {
        ...state,
        success: action.error,
      };

    default:
      return state;
  }
};

export default UpdateApplicantReducer;
